import { configureStore } from "@reduxjs/toolkit";
// import storage from 'redux-persist/lib/storage';
import storageSession from 'redux-persist/lib/storage/session'
import { persistReducer, persistStore, FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER, } from 'redux-persist';
// import thunk from 'redux-thunk';
import { rootReducer } from "./reducers";

const persistConfig = {
    key: 'root',
    version: 1,
    storage: storageSession,
    whitelist: ["user", "locations","uploadEmergencyOrderFile","uploadManualOrderFile","reasonCodes","cutOffTime"]
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const storeSetup = preloadedState => {
    return configureStore({
    reducer: persistedReducer,
    preloadedState,
    devTools: process.env.NODE_ENV !== 'production',
    // middleware: [thunk],
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }),
})
};

export const store =      configureStore({
    reducer: persistedReducer,
    devTools: process.env.NODE_ENV !== 'production',
    // middleware: [thunk],
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }),
})
;

export const persistor = persistStore(store)